<template>
    <div>
        <b-modal 
        v-model="modalShow"
        id="modal-recommend" :centered="true" hide-footer
         @hide="handleHideModal"
        >
            <template #modal-header="{ close }">
                <img class="close" src="@/assets/img/close_red.png" @click="close()">
                <h6 class="sub-title"><span class="sub-title-modal">{{$t('modals.modal-recommend.titulo')}}</span></h6>
            </template>
            <div class="score-buttons">
                <button class="btn bold" :class="[item==ratingValue? 'active': '']" @click="getClickRating(item)" v-for="(item) in arrayQualification" :key="item">{{item}}</button>
            </div>
            <div class="d-flex justify-content-between">
                <span>{{$t('modals.modal-recommend.options.nothing')}}<br/>{{$t('modals.modal-recommend.options.probable')}}</span>
                <span class="text-right">{{$t('modals.modal-recommend.options.Very')}}<br/>{{$t('modals.modal-recommend.options.probable')}}</span>
            </div>
            <b-form-group :label="$t('modals.score-teacher.text-comment')" class="mt-4">
                <b-form-textarea
                v-model="comment"
                    rows="4"
                    no-resize
                ></b-form-textarea>
            </b-form-group>
            <div class="text-center">
                <b-button @click="registerScore" :class="{ loading: isLoading }" :disabled="ratingValue == null"  variant="primary">{{$t('modals.modal-recommend.options.Qualify')}}</b-button>
            </div>
        </b-modal>
    </div>
   
</template>
<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
export default {
	name:"modalRecommend",
	data() {
		return {
            arrayQualification : [
                0,1,2,3,4,5,6,7,8,9,10
            ],
            modalShow :false,
            flagText :false,
            message: '',
            isLoading: false,
			typeScore : 1 ,// 1 - calificacion a ingles advanced  , 2 - calificación al profesor
            personTeacherId : 0,
            nameTeacher : '',
            ratingValue : null,
            comment: '',
            idCalification: 0
		}
	},
	mounted() {
	},
	methods: {
        handleHideModal(){
            this.$store.dispatch("updateFlagValidateCalifications",false); 
            
        },  
        getClose(){
            this.flagText = false; 
            this.$store.dispatch("updateFlagValidateCalifications",false); 
            this.$bvModal.hide('modal-recommend');
        },
        getClickRating(item){
            this.ratingValue = item
        },
        
        registerScore(){
            this.isLoading = true;
                let json = {
                    //PersonTeacherId: this.personTeacherId,
                    Qualification: this.ratingValue,
                    Commentary: this.comment,
                    PersonStudentId :this.$store.state.user.personStudentId,
                    UserCreated : this.$store.state.user.email
                }

           
           baseInstanceAxios
                .post(`${this.apiURL}/resources/EnglishAdvanceCalifications/Save`, json)
                .then(response => {
                   
                    if(response.data.value>0){
                        this.$store.dispatch("updateFlagValidateCalifications",false)
                        this.$emit('close-window-recommend')
                        this.isLoading  = false;
                        this.flagText = true;
                        this.comment = '';
                        this.ratingValue = 0;
                        this.$bvModal.hide('modal-recommend')
                    }
                
                  
                })
                /*.catch(error => {
               
                    this.message = this.$t('my-cours.mesage-system-error');
                    this.$bvToast.show("toast-error-score");
                    this.isLoading = false;
                });*/
            
          
        },
        getShowModalScoreIA(item){
            this.typeScore = item.typeScore;
            this.modalShow = true;
        },
        registerScoreIA(){
            this.isLoading = true;
         
        },

        
	}

}
</script>